var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 28,
    viewBox: "0 0 94 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23334 3.03331H14.9333C15.6333 3.03331 17.7333 2.79998 18.6667 6.06664C19.3667 8.16664 20.3 11.4333 21.7 16.3333H22.1667C23.5667 11.2 24.7333 7.69998 25.2 6.06664C26.1333 2.79998 28.4667 3.03331 29.4 3.03331H36.6333V25.4333H29.1667V12.1333H28.7L24.7333 25.4333H19.1333L15.1667 12.1333H14.4667V25.4333H7.23334M39.6667 3.03331H47.1333V16.3333H47.8333L52.7333 5.36664C53.6667 3.26664 55.7667 3.03331 55.7667 3.03331H62.7667V25.4333H55.3V12.1333H54.8333L49.9333 23.1C49 25.2 46.6667 25.4333 46.6667 25.4333H39.6667M72.8 18.6666V25.4333H65.8V13.7666H88.6667C87.7333 16.5666 84.4667 18.6666 80.7333 18.6666",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1333 12.3667C90.0666 8.16666 87.2666 3.03333 81.2 3.03333H65.3333C65.8 7.93333 70 12.3667 74.4333 12.3667",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.4df2ba55fcea0c535fbc0c585e594fb7.svg";
export { ForwardRef as ReactComponent };